import React from "react";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";

import { Grid, Dialog, DialogContent } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import { IValuesStore } from "Stores/Values/types";
import AddIcon from "@material-ui/icons/Add";
import { AuthProvider } from "@src/Interfaces/Entity/OAuthProvider";
import AuthProviderForm from "../AuthProviderForm/AuthProviderForm";
import { Values } from "@src/Tools/Values";
import { IFile } from "@src/Interfaces/Entity/File";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
class AddAuthProvider extends React.Component<IProps> {
  @observable opened: boolean = false;

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  handleCreate = async (values: AuthProvider) => {
    try {
      values.id = "00000000-0000-0000-0000-000000000000";
      const oauthProvider: AuthProvider = await this.props.management.saveOAuthProvider(values, true);
      if (values.type === this.props.values.oAuthProviderTypes.Custom && values.fileImage) {
        if (values.fileImage.name === "reset") {
          oauthProvider.iconId = this.props.values.common.EmptyId;
          oauthProvider.iconUrl = "";
        } else if (values.fileImage.name !== "default") {
          const file: IFile = await this.props.management.uploadFile(
            values.fileImage,
            oauthProvider.id,
            this.props.values.fileTypes.OAuthProviderIconImage
          );
          oauthProvider.iconId = file.id;
          oauthProvider.iconUrl = file.url;
        }
        await this.props.management.saveOAuthProvider(oauthProvider);
      }
      this.handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const initialValues: AuthProvider = new AuthProvider();
    return (
      <Grid item>
        <RoundButton
          icon={<AddIcon/>}
          tooltipTitle={Values.getLocalizationValue("add")}
          onClick={() => this.handleOpen()}
          color={"green"}
        />
        
        <Dialog open={this.opened} onClose={this.handleClose}>
          <DialogContent>
            <AuthProviderForm
              title={Values.getLocalizationValue("add")}
              initialValues={initialValues}
              onSubmit={this.handleCreate}
              onClose={this.handleClose}
            />
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

export default AddAuthProvider;
